<template>
	<div id="IntegracoesComponent" class="text-left menu-component">
    	<h4>Integrações</h4>

		<div class="row mx--4">
			<div class="w-100 py-4">
				<Integrations :siteId="this.siteId"></Integrations>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<CustomIntegrationsList 
					:list="customIntegrationsList" 
					@editItem="editItem"
					@addNewItem="openNewLinkModal"
				/>
			</div>
		</div>

		<b-modal
			id="customLinkModal"
			ref="customLinkModal"
			title="Adicionar Rede Social"
			centered
			modal-class="bg-white"
			content-class="no-border"
			dialog-class="modal-lg"
			hide-footer
			@ok="addNewCustomIntegration()"
			@close="resetCustomLinkModal()"
			@hide="resetCustomLinkModal()"
		>
			<div class="row justify-content-between align-items-center">
				<div class="col-12 mb-3">
					<label for="">Rede Social:</label>
					<select v-model="customIntegrationHandle.api" class="form-control mb-3">
						<option selected disabled value="0">Escolha uma rede social</option>
						<option :value="option.id" v-for="option in integrationsOptions" :key="option.id">{{option.name}}</option>
						\
					</select>
					<label for="">Seu endereço:</label>
					<input 
						type="text" class="form-control" 
						v-model="customIntegrationHandle.link"
					>
				</div>
				<div class="col-auto">
					<span v-if="customIntegrationHandle.id != null" class="icon-button" @click="confirmDeleteIntegration">
						<i class="far fa-trash"></i>
					</span>
				</div>
				<div class="col-auto">
					<button 
						class="btn btn-primario btn-medium" @click="handleSaveCustonIntegration" 
						:disabled="isLoadingApi">
							Salvar
					</button>
				</div>
			</div>
		</b-modal>

    	<div class="form-group">
      		<label>
        		<strong>
					ID de acompanhamento 
					<a href="https://analytics.google.com" target="_blank">
						Google Analytics
					</a>
					<i title="Utilize a ferramenta gratuita do Google Analytics para ter relatórios altamente detalhados sobre os acessos em seu site." class="question-color fal fa-question-circle"></i>
				</strong>
      		</label>
			<!-- <the-mask
				type="text"
				class="form-control"
				v-model="userCodes.analyticsId"
				:mask="'AA-#########-#'"
				:masked="true"
				placeholder="AA-000000000-0"
			/> -->
			<input 
				type="text" 
				class="form-control" 
				placeholder="AA-000000000-0" 
				maxlength="14" 
				v-model="userCodes.analyticsId" 
			/>
		</div>

		<div class="form-group">
      		<label>
        		<strong>
					ID de acompanhamento 
					<a href="https://analytics.google.com" target="_blank">
						Google Analytics V4
					</a>
					<i title="Utilize a ferramenta gratuita do Google Analytics para ter relatórios altamente detalhados sobre os acessos em seu site." class="question-color fal fa-question-circle"></i>
				</strong>
      		</label>
			
			<input 
				type="text" 
				class="form-control" 
				placeholder="A-AAAAAAAAAA" 
				maxlength="14" 
				v-model="userCodes.analyticsIdV4" 
			/>
		</div>

    	<div class="form-group">
      		<label>
        		<strong>
					Facebook 
					<a href="https://www.facebook.com/events_manager2/list" target="_blank">
						Pixel
					</a>
				</strong>
      		</label>
			<the-mask
				type="tel"
				class="form-control"
				:mask="'###################'"
				v-model="userCodes.pixelId"
			/>
    	</div>

    	<div class="form-group">
      		<p class="my-2 alertMessage" v-if="alertMessage">{{ alertMessage }}</p>
      		<button class="btn btn-primario btn-block" @click="updateCodes" v-if="!updating">Aplicar</button>
      		<button class="btn btn-primario btn-block" disabled v-else>Aplicando</button>
    	</div>

  	</div>
</template>

<script>
import axios from "axios";
import Integrations from "./Integrations";
import CustomIntegrationsList from "./molecules/CustomIntegrationsList";
import apiMixins from "@/mixins/apiMixins";
import apisList from "@/mixins/apisList";
export default {
	name: "IntegracoesComponent",
	data() {
		return {
			alertMessage: "",
			customIntegrationsList: [],
			customIntegrationHandle:{
				id: null,
				link: '',
				api: 0,
			},
			isLoadingApi: false,
			userCodes: {
				pixelId: "",
				analyticsId: "",
				analyticsIdV4: ""
			},
			updating: false
		};
	},
	mixins: [apiMixins, apisList],
	props: {
		siteId: {
		type: Number,
		required: true
		}
	},
	components: {
		Integrations,
		CustomIntegrationsList
	},
	methods: {
		async addNewCustomIntegration(){
			const siteId = localStorage.siteId;
			const url = `/site/${siteId}/link/create`;
			const data = this.customIntegrationHandle;
			const responseApi = await this.requestApiData(url, "post", data);
			if(responseApi.status == 1){
				this.updateCustomIntegrationsList(responseApi.data, 'push')
			}else{
				alert('Erro ao criar Rede Social')
			}
		},
		async fetchCustomIntegrations() {
			const siteId = localStorage.siteId;
			const url = `/site/${siteId}/link`;
      		const responseApi = await this.requestApiData(url, "get");
			this.customIntegrationsList = responseApi.data;
		},
		getCodes() {
			let token = localStorage.getItem("jwt");
			axios({
				method: "get",
				url: process.env.ROOT_API + "api/site/" + this.siteId + "/analytics",
				data: "",
				headers: {
				Authorization: "Bearer " + token
				// 'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
			.then(response => {
				if (response.data.status == 1) {
					this.userCodes.pixelId = response.data.data.pixelId;
					this.userCodes.analyticsId = response.data.data.analyticsId;
					this.userCodes.analyticsIdV4 = response.data.data.analyticsIdV4;
				}
				})
			.catch(response => {
				console.log(response);
			});
		},
		updateCodes() {
			this.alertMessage = "";
			this.updating = true;
			let token = localStorage.getItem("jwt");
			let totalData = this.userCodes;
			axios({
				method: "post",
				url: `${process.env.ROOT_API}api/site/${this.siteId}/analytics/update`,
				data: totalData,
				headers: {
				Authorization: "Bearer " + token
				// 'Content-Type': 'application/x-www-form-urlencoded'
				}
			})
			.then(response => {
				if (response.data.status == 1) {
					this.alertMessage = "Códigos aplicados com sucesso";
				} else {
					this.alertMessage = "Erro ao aplicar códigos";
				}
				this.updating = false;
			})
			.catch(response => {
				this.alertMessage = "Erro ao aplicar códigos";
				this.updating = false;
			});
		},
		editItem(itemId){
			const itemToEdit = this.customIntegrationsList.find(item => item.id == itemId)
			this.customIntegrationHandle = {...itemToEdit};
			this.openNewLinkModal();
		},
		openNewLinkModal(){
			 this.$refs['customLinkModal'].show();
		},
		closeNewLinkModal(){
			this.$refs['customLinkModal'].hide();
		},
		resetCustomLinkModal(){
			this.customIntegrationHandle = {
				id: null,
				link: '',
				api: 0,
			}
		},
		async updateCustomIntegration(){
			const siteId = localStorage.siteId
			const url = `/site/${siteId}/link/${this.customIntegrationHandle.id}/update`;
			const data = this.customIntegrationHandle;
			const responseApi = await this.requestApiData(url, "post", data);
			if(responseApi.status == 1){
				this.updateCustomIntegrationsList(responseApi.data, 'update')
			}else{
				alert('Erro ao atualizar Rede Social')
			}
		},
		updateCustomIntegrationsList(item, action){
			const itemIndex = this.customIntegrationsList.findIndex(integration => integration.id == item.id)
			if(itemIndex >= 0){
				if(action === 'update'){
					this.customIntegrationsList[itemIndex] = item;
				}else{
					this.customIntegrationsList.splice(itemIndex, 1)
				}
			}else{
				this.customIntegrationsList.push(item);
			}
			this.isLoadingApi = false;
			this.closeNewLinkModal();
		},
		handleSaveCustonIntegration(){
			this.isLoadingApi = true;
			if(this.customIntegrationHandle.id == null){
				this.addNewCustomIntegration()
			}else{
				this.updateCustomIntegration();
			}
		},
		confirmDeleteIntegration(){
			this.$bvModal
			.msgBoxConfirm("Este link será removido do seu site", {
				title: "Excluir rede social?",
				modalClass: "full-white",
				size: "md",
				buttonSize: "sm",
				cancelVariant: "default",
				okTitle: "Excluir",
				cancelTitle: "Voltar",
				footerClass: "p-2",
				hideHeaderClose: true,
				centered: true,
			})
			.then((value) => {
				if (value) {
					this.deleteCustomIntegration()
				}
			});
		},
		async deleteCustomIntegration(){
			this.isLoadingApi = true;
			const siteId = localStorage.siteId;
			const url = `/site/${siteId}/link/${this.customIntegrationHandle.id}/delete`;
			const data = this.customIntegrationHandle;
			const responseApi = await this.requestApiData(url, "post", data);
			if(responseApi.status == 1){
				this.updateCustomIntegrationsList(this.customIntegrationHandle, 'remove')
			}else{
				alert('Erro ao deletar Rede Social')
			}
		}
	},
	created() {
		this.getCodes();
		this.fetchCustomIntegrations()
	}
};
</script>
<style >
.modal-content{
	border: none!important;
}
</style>
<style scoped>
.icon-button{
	color: #7B7B7B;
	cursor: pointer;
}
label {
    margin-bottom: 0;
    font-size: 0.85rem;
    color: rgba(0, 0, 0, 0.32);
    font-weight: 700;
    font-size: 0.6rem;
}
input,input:focus {
	background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/IntegracoesComponent.vue